import { useTranslation } from "react-i18next";
import AlertPopupModal from "../../Common/AlertPopupModal";

// Renders the shared AlertPopupModal rather than re-creating its markup, so this
// popup is identical to the design by construction and cannot drift from it:
// close x, title, message, alert icon, Confirm button. AlertPopupModal itself is
// untouched - nothing is hidden or overridden, it is used exactly as every other
// caller uses it.
//
// Kept as a named component (rather than calling AlertPopupModal directly from
// CalendarEvent) because the copy and the dismiss semantics below belong
// together in one place.
//
// Dismissing is safe. This popup is purely informational: CalendarUI opens it
// when the user clicks a date cell that is ALREADY showing its own per-date
// loader (`loadingprocessModal()`, CalendarUI.jsx:110). It does not own that
// request and cancels nothing - the in-flight call belongs to the booking/cancel
// handlers, which clear `showBookingProcess` in their own `finally` whether or
// not the user closed this first, so an early close cannot desync anything.
//
// It carried a spinning `refreshloader.gif` until 2026-09-17. Removed on request:
// the date cell underneath is already animating its own loader, so a second
// animation inside the message was duplicate feedback.
//
// `role="status"` + `aria-live="polite"` wrap the popup because AlertPopupModal
// has no live region of its own - without them the wait is never announced to
// assistive tech. The wrapper is unstyled and the modal inside is positioned, so
// it adds nothing to the layout.
const LoadingProcessModal = ({ onClose }) => {
    const { t } = useTranslation();

    return (
        <div role="status" aria-live="polite">
            <AlertPopupModal
                title={t("alert")}
                message={t("calender_request_pending_will_processed")}
                onClose={onClose}
                withBackdrop
            />
        </div>
    );
};

export default LoadingProcessModal;
